import React, { useEffect } from 'react'
import useExecScripts from '../Component/useExecScripts'

function AlpphaFoods() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const containerRef = useExecScripts();

	return (
		<div id="content" className="site-content">
			<div className="ast-container">
				<div id="primary" className="content-area primary">
					<main id="main" className="site-main">
						<article className="page type-page status-publish ast-article-single">
							<header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
							<div ref={containerRef}>
								<div className="entry-content clear" itemProp="text">


									<div data-elementor-type="wp-page" data-elementor-id="2125"
										className="elementor elementor-2125">
										<div className="elementor-element elementor-element-f53c655 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent"
											data-id="f53c655" data-element_type="container" data-e-type="container">
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-cbe9bc3 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child"
													data-id="cbe9bc3" data-element_type="container" data-e-type="container">
													<div className="elementor-element elementor-element-945de3b elementor-widget__width-inherit elementor-widget elementor-widget-elementskit-heading"
														data-id="945de3b" data-element_type="widget" data-e-type="widget"
														data-widget_type="elementskit-heading.default">
														<div className="elementor-widget-container">
															<div className="ekit-wid-con">
																<div
																	className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
																	<h2
																		className="ekit-heading--title elementskit-section-title ">
																		Alppha Foods </h2>
																	<h3
																		className="ekit-heading--subtitle elementskit-section-subtitle  ">
																		A One-Stop Solution for All Corporate Needs
																	</h3>
																</div>
															</div>
														</div>
													</div>
													<div className="elementor-element elementor-element-58fb220 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child"
														data-id="58fb220" data-element_type="container"
														data-e-type="container"
														data-settings='{"background_background":"classic","shape_divider_bottom":"triangle"}'>
														<div className="elementor-shape elementor-shape-bottom"
															aria-hidden="true" data-negative="false">
															<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100"
																preserveaspectratio="none">
																<path className="elementor-shape-fill"
																	d="M500,98.9L0,6.1V0h1000v6.1L500,98.9z"></path>
															</svg>
														</div>
														<div className="elementor-element elementor-element-342087f e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child"
															data-id="342087f" data-element_type="container"
															data-e-type="container">
															<div className="elementor-element elementor-element-0eb916c elementor-widget elementor-widget-image"
																data-id="0eb916c" data-element_type="widget"
																data-e-type="widget" data-widget_type="image.default">
																<div className="elementor-widget-container">
																	<img decoding="async" width="626" height="351"
																		src="/assets/images/01/custam.avif"
																		className="attachment-large size-large wp-image-197"
																		alt=""
																		srcSet="/assets/images/01/custam.avif 626w, /assets/images/01/custam-300x168.avif 300w"
																		sizes="(max-width: 626px) 100vw, 626px" />
																</div>
															</div>
														</div>
														<div className="elementor-element elementor-element-95e7155 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child"
															data-id="95e7155" data-element_type="container"
															data-e-type="container">
															<div className="e-con-inner">
																<div className="elementor-element elementor-element-f5b974d elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
																	data-id="f5b974d" data-element_type="widget"
																	data-e-type="widget"
																	data-widget_type="icon-list.default">
																	<div className="elementor-widget-container">
																		<ul className="elementor-icon-list-items">
																			<li className="elementor-icon-list-item">
																				<span
																					className="elementor-icon-list-text">Stringent
																					7-point quality checks for all
																					ingredients.</span>
																			</li>
																			<li className="elementor-icon-list-item">
																				<span className="elementor-icon-list-text">Top
																					notch Qaulity at affordable price
																				</span>
																			</li>
																			<li className="elementor-icon-list-item">
																				<span className="elementor-icon-list-text">30
																					days 30 different menus </span>
																			</li>
																			<li className="elementor-icon-list-item">
																				<span
																					className="elementor-icon-list-text">Expert
																					Managers to manager canteen operations
																				</span>
																			</li>
																			<li className="elementor-icon-list-item">
																				<span className="elementor-icon-list-text">food
																					as per the upcoming events </span>
																			</li>
																			<li className="elementor-icon-list-item">
																				<span
																					className="elementor-icon-list-text">Fresh,
																					in-house gravies made from
																					scratch</span>
																			</li>
																		</ul>
																	</div>
																</div>
																<div className="elementor-element elementor-element-3f7878b elementor-invisible elementor-widget elementor-widget-ucaddon_parellogram_button"
																	data-id="3f7878b" data-element_type="widget"
																	data-e-type="widget"
																	data-settings='{"_animation":"fadeInUp"}'
																	data-widget_type="ucaddon_parellogram_button.default">
																	<div className="elementor-widget-container">
<div id="uc_parellogram_button_elementor_3f7878b"
																			className="parellogram_button">
																			<a className="ue_button ue_parallelogram" href="">
																				<span className="ue_skew-fix">MENU LINK</span>
																			</a>
																		</div>
																		{/* end Parallelogram Button */}
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>



								</div>
							</div>
						</article>
					</main>
				</div>
			</div>
		</div>
	)
}

export default AlpphaFoods
